import React from "react";
import Items from "./Items";
import styles from "../NotesPage.module.scss";
const List = ({ notes, label, setNotes }) => {
 
  return (
    <>
      <h2>{label}</h2>
      <div className={styles["notes-list"]}>
        {notes.length === 0 ? (
          <p className={styles["notes-list__empty-message"]}>Заметки не найдены</p>
        ) : (
          notes.map((note) => (
            <Items action={setNotes} key={note.id} {...note} />
          ))
        )}
      </div>
    </>
  );
};

export default List;
